import { render, staticRenderFns } from "./BaseTSREdit.vue?vue&type=template&id=5b8fc811"
import script from "./BaseTSREdit.vue?vue&type=script&lang=js"
export * from "./BaseTSREdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports